var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('step-indicator',{attrs:{"current":this.progress.value - 1,"total":this.progress.maximum,"currentColor":'rgb(68, 200, 204)',"defaultColor":'rgb(200, 200, 200)'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }